// Age-group pack registry. The Icon engine selects a pack by age group; each
// pack maps the shared canonical IconNames to its own glyph artwork.
//
// Only the 14–18 (learner) pack exists today and is the default. When the 10–14
// set is provided, add `packs/kid.ts`, import it here, add a "10-14" member to
// AgePack + PACKS, and (optionally) switch DEFAULT_PACK / drive selection from
// the learner's grade. No engine or call-site change is required.

import { IconType } from "react-icons";
import { IconName } from "../iconNames";
import { TEEN_PACK } from "./teen";

export type AgePack = "14-18"; // | "10-14" (added when the kid set ships)

export const PACKS: Record<AgePack, Record<IconName, IconType>> = {
  "14-18": TEEN_PACK,
};

export const DEFAULT_PACK: AgePack = "14-18";

export const getPack = (pack?: AgePack): Record<IconName, IconType> =>
  PACKS[pack ?? DEFAULT_PACK];
